import { resetAndStopAnimation } from '@ps/bridge/qc/node'
import { filter } from '@ps/bridge/qc/node/utils'
import store from '@ps/store'
import i18n from '@ps/lang'
import { hasPermission } from '@ps/plugins/permission-manager/manager'
import keys from '@ps/permission/keys'
import _ from 'lodash'
import { isPlayScene } from '@ps/bridge/qc/scripts/scene-config'
import { hasSelfDevPermission } from '@ps/permission/workbench'
import nodePool from '@ps/bridge/qc/node-pool'
import {
  getDrawLineInScene,
  isDrawLineAreaNode,
  isConnectDrawLineNode,
  isFreeDrawLineNode,
  isEraseNode,
  isEraseNodeChild,
  getEraseNodeInScene,
  isMaskComponentNodeChild,
  getMaskComponentNodeInScene,
  isMaskComponentNode,
  isCarouselNode,
  isCarouselNodeChild,
  getCarouselNodeInScene,
  isDragBound,
  isDragTargetArea,
  isVideo,
  isAudio,
} from '@ps/bridge/qc/base'
import { GeneralMode } from '@ps/types/workbench/stage.type'
import { eraseToInit } from '@ps/workbench/undo-redo/module/erase'
import { isIvPage } from '@ps/router/config'
function getTabBarList(tabList) {
  return [
    {
      value: 'design',
      label: i18n.t('workbench.globalSetting.tabBarList.design'),
      visible: true,
    },
    {
      value: 'animation',
      label: i18n.t('workbench.globalSetting.tabBarList.animation'),
      visible: true,
    },
    {
      value: 'scene',
      label: i18n.t('workbench.globalSetting.tabBarList.scene'),
      visible: hasPermission(keys.sceneSetting),
    },
    {
      value: 'global',
      label: i18n.t('workbench.globalSetting.tabBarList.global'),
      visible: hasPermission(keys.globalSetting),
    },
    {
      value: 'drawLine',
      label: i18n.t('workbench.drawLine.drawLineEdit.drawLineArea'),
      visible: true,
    },
    {
      value: 'freeDrawLine',
      label: i18n.t('workbench.drawLine.freeDrawLineEdit.tab'),
      visible: true,
    },
    {
      value: 'erase',
      label: i18n.t('workbench.erase.eraseSetting'),
      visible: true,
    },
    {
      value: 'carousel',
      label: i18n.t('workbench.carousel.carouselSetting'),
      visible: true,
    },
    {
      value: 'mask',
      label: i18n.t('workbench.mask.maskSetting'),
      visible: true,
    },
    {
      value: 'event',
      label: i18n.t('workbench.globalSetting.tabBarList.event'),
      visible: hasPermission(keys.eventSetting),
    },
    {
      value: 'gameConfig',
      label: i18n.t('workbench.globalSetting.tabBarList.gameConfig'),
      visible: hasPermission(keys.gameConfigSetting),
    },
    {
      value: 'selfDevScript',
      label: '自定义玩法',
      visible: hasSelfDevPermission(),
    },
  ].filter((item) => tabList.some((j) => j === item.value) && item.visible)
}

function updateActiveTab(state, tab) {
  const preTab = state.tabBar.activeTab
  state.tabBar.activeTab = tab
  const scene = store.state.workspace.sceneManager.currentSceneNode
  // 从动画 tab 切换到其他 tab，重置动画
  if (preTab === 'animation' && preTab !== tab) {
    if (scene) {
      const nodeList = filter(scene, (item) => item.getScript('qc.Tween'))
      nodeList.forEach((node) => resetAndStopAnimation(node))
    }
  }
  if (tab === 'drawLine') {
    store.commit('workspace/stage/updateDrawLineMode', GeneralMode.Editable)
    store.commit('workspace/stage/updateDrawLineAreaMode', GeneralMode.Editable)
  }
  if (tab === 'freeDrawLine') {
    store.commit('workspace/stage/updateDrawLineMode', GeneralMode.Editable)
  }
  // 从起止区域的tab切换到其他tab
  const activeNode = store.state.workspace.game.activeNode
  if (preTab === 'drawLine' && preTab !== tab) {
    if (isConnectDrawLineNode(activeNode) || isDrawLineAreaNode(activeNode)) {
      store.commit('workspace/stage/updateDrawLineMode', GeneralMode.Editable)
    } else {
      store.commit('workspace/stage/updateDrawLineMode', GeneralMode.None)
    }
    store.commit('workspace/stage/updateDrawLineAreaMode', GeneralMode.None)
    // 当前是连线组件或其区域子节点，需要设置activeNode为连线组件
    if (isConnectDrawLineNode(activeNode) || isDrawLineAreaNode(activeNode)) {
      const node = getDrawLineInScene(scene)
      store.dispatch('workspace/game/updateActiveNode', {
        node,
        record: false,
      })
    }
  }
  if (preTab === 'erase' && preTab !== tab) {
    // 当前是擦除组件或其子节点，需要设置activeNode为擦除组件
    if (isEraseNodeChild(activeNode)) {
      const node = getEraseNodeInScene(scene)
      eraseToInit([node])
      store.dispatch('workspace/game/updateActiveNode', {
        node,
        record: false,
      })
    }
  }
  if (preTab === 'mask' && preTab !== tab) {
    // 当前是遮罩组件或其子节点，需要设置activeNode为遮罩组件
    if (isMaskComponentNodeChild(activeNode)) {
      const node = getMaskComponentNodeInScene(scene)
      // eraseToInit([node])
      store.dispatch('workspace/game/updateActiveNode', {
        node,
        record: false,
      })
    }
  }
  if (preTab === 'carousel' && preTab !== tab) {
    // 当前是轮播组件或其子节点，需要设置activeNode为轮播组件
    if (isCarouselNodeChild(activeNode)) {
      const node = getCarouselNodeInScene(scene)
      // eraseToInit([node])
      store.dispatch('workspace/game/updateActiveNode', {
        node,
        record: false,
      })
    }
  }
  // 事件系统里有显示区域的入口,切换tab需要清除显示
  if (tab !== 'drawLine' && isConnectDrawLineNode(activeNode)) {
    store.commit('workspace/stage/updateDrawLineMode', GeneralMode.Editable)
    store.commit('workspace/stage/updateDrawLineAreaMode', GeneralMode.None)
  }
}

export default {
  namespaced: true,

  state: {
    tabBar: {
      // 初始化时只有 stage pane
      list: [],
      activeTab: 'scene',
    },
  },

  mutations: {
    updateTabBarList(state, tabList) {
      state.tabBar.list = getTabBarList(tabList)
    },

    updateActiveTab(state, tab) {
      updateActiveTab(state, tab)
    },

    // 节点配置展示的tab，一般是选择节点时调用
    switchToNodeConfigTab(state, { activeTab } = {}) {
      let tabList = ['design', 'animation', 'event', 'selfDevScript']
      if (store.state.workspace.game.activeNode) {
        const node = nodePool.find(store.state.workspace.game.activeNode.uuid)
        if (isIvPage() && (isVideo(node) || isAudio(node))) {
          // 互动视频编辑器的视频和音频不显示动画和事件tab
          tabList.splice(tabList.indexOf('animation'), 1)
          tabList.splice(tabList.indexOf('event'), 1)
        }
        if (isDragBound(node) || isDragTargetArea(node)) {
          return
        }
        if (isConnectDrawLineNode(node) || isDrawLineAreaNode(node)) {
          tabList.push('drawLine')
          tabList = tabList.filter((tab) => tab !== 'animation')
        } else if (isFreeDrawLineNode(node)) {
          tabList.push('freeDrawLine')
          tabList = tabList.filter((tab) => tab !== 'animation')
        } else if (isEraseNode(node) || isEraseNodeChild(node)) {
          tabList.push('erase')
        } else if (isCarouselNode(node) || isCarouselNodeChild(node)) {
          // 画布中选中遮罩子元素时，自动切换到遮罩设置tab
          if (isCarouselNodeChild(node)) {
            state.tabBar.activeTab = 'carousel'
            activeTab = 'carousel'
          }
          tabList.push('carousel')
        } else if (
          isMaskComponentNode(node) ||
          isMaskComponentNodeChild(node)
        ) {
          // 画布中选中遮罩子元素时，自动切换到遮罩设置tab
          if (isMaskComponentNodeChild(node)) {
            state.tabBar.activeTab = 'mask'
            activeTab = 'mask'
          }
          tabList.push('mask')
        }
      }
      state.tabBar.list = getTabBarList(tabList)
      // 当选择节点时，当前tab不是 animation 或 event，切换到 design tab
      if (
        [
          'animation',
          'event',
          'selfDevScript',
          'drawLine',
          'erase',
          'carousel',
          'mask',
        ].every((item) => item !== state.tabBar.activeTab) ||
        tabList.indexOf(state.tabBar.activeTab) === -1
      ) {
        updateActiveTab(state, activeTab || 'design')
      }
    },
  },

  actions: {
    // 场景配置展示的tab，一般是选择场景或者没有当前节点的时候调用
    async switchToStageConfigTab(
      { state, rootState, dispatch },
      { activeTab } = {},
    ) {
      if (rootState.workspace.game.lockEditAll) {
        return
      }
      if (isIvPage()) {
        // 互动视频清空所有tab
        dispatch('clearTab')
        return
      }
      const currentScene = rootState.workspace.sceneManager.currentSceneNode
      if (!currentScene) return
      const sceneGameConfig = await dispatch(
        'workspace/gameConfig/getSceneGameConfig',
        currentScene.uniqueName,
        { root: true },
      )
      let tabBarKeys = ['scene', 'event']
      if (!_.isEmpty(sceneGameConfig)) {
        tabBarKeys.push('gameConfig')
      }
      // 如果是玩法场景，不允许显示 scene 和 event
      if (isPlayScene(currentScene)) {
        tabBarKeys = ['selfDevScript']
        activeTab = 'selfDevScript'
      }
      state.tabBar.list = getTabBarList(tabBarKeys)
      updateActiveTab(state, activeTab || 'scene')
    },

    async switchToGlobalConfigTab({ state, dispatch }) {
      const sceneGameConfig = await dispatch(
        'workspace/gameConfig/getCommonGameConfig',
        null,
        { root: true },
      )
      // 全局场景也支持条件逻辑事件
      const tabBarKeys = ['global', 'event']
      if (!_.isEmpty(sceneGameConfig)) {
        tabBarKeys.push('gameConfig')
      }
      if (isIvPage()) {
        // 互动视频编辑器全局设置里不显示事件tab
        tabBarKeys.splice(tabBarKeys.indexOf('event'), 1)
      }
      state.tabBar.list = getTabBarList(tabBarKeys)
      updateActiveTab(state, 'global')
    },
    async clearTab({ state, dispatch }) {
      state.tabBar.list = []
    },
  },
}
